import React from 'react';
import { Collapse } from 'antd';
import PropTypes from 'prop-types';
import AccordionHeader from './AccordionHeader';

const { Panel } = Collapse;

export default function Accordion({ children, title = '', invoiceCount = 0, visible = true }) {
	if (!visible) {
		return null;
	}

	return (
		<Panel header={<AccordionHeader title={title} invoiceCount={invoiceCount} />}>
			{children}
		</Panel>
	);
}

Accordion.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	title: PropTypes.string,
	invoiceCount: PropTypes.number,
	visible: PropTypes.bool,
};
